
import { 
    Container,
    Row,
    Col
} from "react-bootstrap";
function ExternalPDFPage2(props: any) {
    return (
        <>
            <Container fluid className="text-left page-break cu-pt-10 mt-2">
                <h3 className="cu-fs-18">{props.TranslateString('Sisällys​​​')}</h3>
                <Row >
                    <Col>
                        <ul style={{listStyle:"-  "}} className="cu-fs-12">
                            <li> {props.TranslateString('Perustiedot yhtiöstä ja kilpailutettavasta lainasta')}​ </li>
                            <li> 
                                {props.TranslateString('Analyysin yhteenveto​​')}
                                <ul>
                                    <li>{props.TranslateString('Markkinahintapohjainen indikaatio - Loan to Value')}​</li>
                                    <li>{props.TranslateString('Osakeanalyysi')}</li>
                                </ul>
                            </li>
                        </ul>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default ExternalPDFPage2;